module.exports = __webpack_public_path__ + "static/media/moov.a1c30fe2.jpg";